<template>
  <div class="home container">
    <nav class="panel">
      <p class="panel-heading">
        <translate>Tävlingar</translate>
      </p>
      <div
        v-for="(competition, index) of competitions"
        :key="index"
        class="panel-block">
        <router-link
          :to="'/competition/' + competition.pk">
          {{ competition.name }}
        </router-link>
        <div class="field is-pulled-right has-addons">
          <p class="control">
            <button
              v-if="loggedIn"
              class="button"
              @click="openModal(competition.pk)">
              <translate>Ändra Namn</translate>
            </button>
          </p>
          <router-link
            class="control"
            :to="'/edit/competition/' + competition.pk">
            <button
              v-if="loggedIn"
              class="button">
              <translate>Editera</translate>
            </button>
          </router-link>
          <p class="control">
            <button
              v-if="loggedIn"
              class="button is-danger"
              @click="openDeleteModal(competition.pk)">
              <translate>Radera</translate>
            </button>
          </p>
        </div>
        <b-modal
          :active.sync="isComponentModalActive[competition.pk]">
          <edit-competition :id="competition.pk" />
        </b-modal>
        <b-modal
          :active.sync="isComponentDeleteModalActive[competition.pk]">
          <delete-competition :id="competition.pk" />
        </b-modal>
      </div>
      <button
        v-if="loggedIn"
        class="button is-primary"
        @click="openNewModal()">
        <translate>Skapa Ny Tävling</translate>
      </button>
    </nav>
    <b-modal
      :active.sync="isComponentNewModalActive">
      <new-competition />
    </b-modal>
    <nav
      v-if="loggedIn"
      class="panel">
      <p class="panel-heading">
        <translate>Deltagarländer</translate>
      </p>
      <div
        v-for="(country, index) of countries"
        :key="index"
        class="panel-block">
        <p>
          {{ country.name }}
        </p>
        <div class="field is-pulled-right has-addons">
          <p class="control">
            <button
              class="button"
              @click="openCountryModal(country.pk)">
              <translate>Ändra Namn</translate>
            </button>
          </p>
          <p class="control">
            <button
              v-if="loggedIn"
              class="button is-danger"
              @click="openDeleteCountryModal(country.pk)">
              <translate>Radera</translate>
            </button>
          </p>
        </div>
        <b-modal
          :active.sync="isCountryModalActive[country.pk]">
          <edit-country :id="country.pk" />
        </b-modal>
        <b-modal
          :active.sync="isCountryDeleteModalActive[country.pk]">
          <delete-country :id="country.pk" />
        </b-modal>
      </div>
      <button
        v-if="loggedIn"
        class="button is-primary"
        @click="openNewCountryModal()">
        <translate>Lägg till Deltagarland</translate>
      </button>
      <b-modal
        :active.sync="isCountryNewModalActive">
        <new-country />
      </b-modal>
    </nav>
  </div>
</template>

<script>
import Vue from 'vue'
import { competitionService, countryService } from '../_services';
import NewCompetition from '../components/NewCompetition'
import EditCompetition from '../components/EditCompetition'
import DeleteCompetition from '../components/DeleteCompetition'
import NewCountry from '../components/country/New'
import EditCountry from '../components/country/Edit'
import DeleteCountry from '../components/country/Delete'

export default {
  name: 'HomePage',
  components: {
    NewCompetition,
    EditCompetition,
    DeleteCompetition,
    NewCountry,
    EditCountry,
    DeleteCountry,
  },
  props: {
  },
  data () {
    return {
      competitions: undefined,
      countries: undefined,
      isComponentModalActive: [],
      isComponentDeleteModalActive: [],
      isComponentNewModalActive: false,
      isCountryModalActive: [],
      isCountryDeleteModalActive: [],
      isCountryNewModalActive: false,
    }
  },
  computed: {
    loggedIn () {
      return this.$store.state.authentication.status.loggedIn;
    },
    user () {
      return this.$store.state.authentication.token
    },
  },
  async created () {
    var self = this
    self.competitions = await competitionService.getAll()
    self.countries = await countryService.getAll(self.id)
  },
  methods: {
    openModal: function(id){
      var self = this
      Vue.set(self.isComponentModalActive, id, true)
    },
    openDeleteModal: function(id){
      var self = this
      Vue.set(self.isComponentDeleteModalActive, id, true)
    },
    openNewModal: function(){
      var self = this
      self.isComponentNewModalActive = true
    },
    openCountryModal: function(id){
      var self = this
      Vue.set(self.isCountryModalActive, id, true)
    },
    openDeleteCountryModal: function(id){
      var self = this
      Vue.set(self.isCountryDeleteModalActive, id, true)
    },
    openNewCountryModal: function(){
      var self = this
      self.isCountryNewModalActive = true
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel-block {
  justify-content: space-between;
}
</style>
